import styles from './styles/message.module.css';

export default function FeedbackMessage({ icon, message, subMessage }) {
    return (
        <div className={styles.wrapper}>
            <div>{icon}</div>
            <div>{message}</div>
            <div>{subMessage}</div>
        </div>
    );
}
